import { logger as sentryLogger } from "@sentry/react";
import config from "../config";

// Map MSAL LogLevel to numeric values for comparison
const LOG_LEVELS = {
  Error: 0,
  Warn: 1,
  Info: 2,
  Debug: 3,
};

// Default to Error if not set
const currentLevel = typeof config.LogLevel === "number" ? config.LogLevel : LOG_LEVELS.Error;

function shouldLog(level) {
  // Sentry only logs if the message level is >= config.LogLevel
  return level <= currentLevel;
}

/* eslint-disable no-console */
function createLogger() {
  return {
    log: (...args) => {
      if (shouldLog(LOG_LEVELS.Info)) {
        sentryLogger.info(...args);
        console.log(...args);
      }
    },
    info: (...args) => {
      if (shouldLog(LOG_LEVELS.Info)) {
        sentryLogger.info(...args);
        console.info(...args);
      }
    },
    debug: (...args) => {
      if (shouldLog(LOG_LEVELS.Debug)) {
        sentryLogger.debug(...args);
        console.debug(...args);
      }
    },
    warn: (...args) => {
      if (shouldLog(LOG_LEVELS.Warn)) {
        sentryLogger.warn(...args);
        console.warn(...args);
      }
    },
    error: (...args) => {
      // Add version information to all error logs
      const versionInfo = `[v${config.version}]`;
      if (shouldLog(LOG_LEVELS.Error)) sentryLogger.error(versionInfo, ...args);
      console.error(versionInfo, ...args);
    },
  };
}

export default createLogger();
